/**
 * RootNavigator
 * De grote baas van de navigatie tabs.
 * Hier bepalen we welke knoppen je onderin ziet (Huisje, Vergrootglas, Sterretje).
 */

import React from 'react';
import {Text} from 'react-native';
import {NavigationContainer} from '@react-navigation/native';
import {createBottomTabNavigator} from '@react-navigation/bottom-tabs';
import {useTranslation} from 'react-i18next';
import {HomeStackNavigator} from './HomeStackNavigator';
import {SearchStackNavigator} from './SearchStackNavigator';
import {FavoritesStackNavigator} from './FavoritesStackNavigator';
import type {RootStackParamList} from '../models/Navigation';

const Tab = createBottomTabNavigator<RootStackParamList>();

export const RootNavigator: React.FC = () => {
  const {t} = useTranslation();

  return (
    <NavigationContainer
      linking={{
        prefixes: ['nebulatide://', 'https://nebulatide.app', 'http://localhost:3000'],
        config: {
          screens: {
            HomeTab: 'home',
            SearchTab: 'search',
            FavoritesTab: 'favorites',
          },
        },
      }}
      documentTitle={{
        formatter: (options, route) =>
          `${options?.title ?? route?.name} - NebulaTide`,
      }}>
      <Tab.Navigator
        id={undefined}
        screenOptions={{
          headerShown: false, // We maken onze eigen headers wel, dankje
          tabBarActiveTintColor: '#7B3FF2', // Mooi paars is niet lelijk
          tabBarInactiveTintColor: '#999',
        }}>
        <Tab.Screen
          name="HomeTab"
          component={HomeStackNavigator}
          options={{
            tabBarLabel: t('tabs.home') || 'Thuis',
            tabBarIcon: ({color, size}) => {
              return <Text style={{fontSize: size || 24, color}}>🏠</Text>;
            },
          }}
        />
        <Tab.Screen
          name="SearchTab"
          component={SearchStackNavigator}
          options={{
            tabBarLabel: t('tabs.search') || 'Zoeken',
            tabBarIcon: ({color, size}) => {
              return <Text style={{fontSize: size || 24, color}}>🔍</Text>;
            },
          }}
        />
        <Tab.Screen
          name="FavoritesTab"
          component={FavoritesStackNavigator}
          options={{
            tabBarLabel: t('tabs.favorites') || 'Favorieten',
            tabBarIcon: ({color, size}) => {
              return <Text style={{fontSize: size || 24, color}}>⭐</Text>;
            },
          }}
        />
      </Tab.Navigator>
    </NavigationContainer>
  );
};
